export default "__VITE_ASSET__621d01f5__"